<template>
  <v-app>
    <v-container fluid>
      <site-menu-toolbar/>
      <v-content>
        <slot/>
      </v-content>
    </v-container>
  </v-app>
</template>

<script>
import SiteMenuToolbar from "@/components/SiteMenuToolbar";
export default {
  name: "SiteLayoutPlain",
  components: {
    SiteMenuToolbar,
  }
};
</script>

